module.exports = __webpack_public_path__ + "img/ics_o_wallet.22ebcb10.svg";